"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../model/utils");
var constant_1 = require("../utils/constant");
var localstorage_1 = require("../utils/localstorage");
var wrapper_1 = require("../utils/wrapper");
var login = function (authParams) {
    return wrapper_1.getClients()
        .restClient.post(constant_1.LOGIN_URL, {
        email: authParams.email,
        password: authParams.password,
    })
        .then(function (_a) {
        var data = _a.data;
        if (data === null || data === void 0 ? void 0 : data.saasToken) {
            var saasToken = data.saasToken, marketplaceToken = data.marketplaceToken;
            if (authParams.rememberMe) {
                localstorage_1.storeTokens({ saasToken: saasToken, marketplaceToken: marketplaceToken });
            }
            wrapper_1.updateAuthorization(saasToken, marketplaceToken);
        }
        return { data: data };
    })
        .catch(utils_1.errorHandler);
};
var forgotPassword = function (authParams) {
    return wrapper_1.getClients()
        .restClient.post(constant_1.FORGOT_PASSWORD_URL, authParams)
        .then(function (_) { return ({ data: true }); })
        .catch(utils_1.errorHandler);
};
var logout = function () {
    var _a;
    (_a = wrapper_1.getClients().restClient) === null || _a === void 0 ? void 0 : _a.post(constant_1.LOGOUT_URL).catch(utils_1.errorHandler);
    localstorage_1.clearTokens();
    wrapper_1.updateAuthorization(undefined, undefined);
    return Promise.resolve({ data: true });
};
var fetchUser = function () {
    return wrapper_1.getClients()
        .restClient.get(constant_1.FETCH_USER_URL)
        .then(function (res) { return ({ data: res.data }); })
        .catch(utils_1.errorHandler);
};
var fetchUserCompany = function () {
    var requestUser = wrapper_1.getClients()
        .restClient.get(constant_1.FETCH_USER_URL)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
    var requestCompany = wrapper_1.getClients()
        .restClient.get(constant_1.FETCH_COMPANY_URL)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
    return Promise.all([requestUser, requestCompany])
        .then(function (values) { return ({
        data: __assign(__assign({}, values[0]), { company: values[1] }),
    }); })
        .catch(utils_1.errorHandler);
};
var auth = {
    login: login,
    logout: logout,
    forgotPassword: forgotPassword,
    fetchUser: fetchUser,
    fetchUserCompany: fetchUserCompany,
};
var init = function () { return auth; };
exports.init = init;
